<template>
  <div class="fast-commands-widget">
    <div class="fast-commands-widget__header">
      <div class="fast-commands-widget__icon">
        <svg
          width="18"
          height="17"
          viewBox="0 0 18 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.04894 0.927049C8.3483 0.00573801 9.6517 0.00574028 9.95106 0.927051L11.2451 4.90983C11.379 5.32185 11.763 5.60081 12.1962 5.60081H16.3839C17.3527 5.60081 17.7554 6.84043 16.9717 7.40983L13.5838 9.87132C13.2333 10.126 13.0866 10.5773 13.2205 10.9894L14.5146 14.9721C14.8139 15.8934 13.7595 16.6596 12.9757 16.0902L9.58778 13.6287C9.2373 13.374 8.7627 13.374 8.41221 13.6287L5.02426 16.0902C4.24054 16.6596 3.18607 15.8934 3.48542 14.9721L4.7795 10.9894C4.91338 10.5773 4.76672 10.126 4.41623 9.87132L1.02827 7.40983C0.244561 6.84043 0.647338 5.60081 1.61606 5.60081H5.8038C6.23703 5.60081 6.62099 5.32185 6.75486 4.90983L8.04894 0.927049Z"
            fill="white"
          />
        </svg>
      </div>
      <div class="fast-commands-widget__title">
        {{ $t('fast_commands_widget.title') }}
      </div>
    </div>
    <div class="fast-commands-widget__list">
      <require-access action="read" data="bills-make">
        <router-link
					:to="`/cabinet/company/${selectedCompany}/invoices?create=1`"
          class="fast-commands-widget__item"
        >
          <div class="fast-commands-widget__item-icon">
            <svg
              width="20"
              height="17"
              viewBox="0 0 20 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.7612 10.7754H6.72576L6.72576 1.3459H4.03546L4.03546 10.7754H0L4.67439 15.4381C5.06471 15.8275 5.69651 15.8275 6.08683 15.4381L10.7612 10.7754Z"
                fill="#E3E9FF"
              />
              <path
                d="M19.5044 5.36716L15.4689 5.36716V14.7967H12.7786V5.36716H8.74316L13.4176 0.704456C13.8079 0.315111 14.4397 0.315111 14.83 0.704455L19.5044 5.36716Z"
                fill="#E3E9FF"
              />
            </svg>
          </div>
          <div class="fast-commands-widget__item-text">
            {{ $t('fast_commands.create-bill') }}
          </div>
          <div class="fast-commands-widget__item-arrow">
            <arrow-button></arrow-button>
          </div>
        </router-link>
      </require-access>
      <require-access action="read" data="payout-to-card-make_payout">
        <router-link
          :to="`/cabinet/company/${selectedCompany}/payouts/to-card/create`"
          class="fast-commands-widget__item"
        >
          <div class="fast-commands-widget__item-icon">
            <svg
              width="13"
              height="17"
              viewBox="0 0 13 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.1333 0.107133L10.8333 1.59448L8.99167 0.107133C8.89813 0.0376569 8.78401 5.6811e-05 8.66667 5.6811e-05C8.54933 5.6811e-05 8.4352 0.0376569 8.34167 0.107133L6.5 1.59448L4.65833 0.107133C4.5648 0.0376569 4.45067 5.6811e-05 4.33333 5.6811e-05C4.216 5.6811e-05 4.10187 0.0376569 4.00833 0.107133L2.16667 1.59448L0.866667 0.107133C0.507812 -0.155144 0 0.0938532 0 0.532088V16.4679C0 16.9061 0.507812 17.1551 0.866667 16.8929L2.16667 15.4055L4.00833 16.8929C4.10187 16.9623 4.216 16.9999 4.33333 16.9999C4.45067 16.9999 4.5648 16.9623 4.65833 16.8929L6.5 15.4055L8.34167 16.8929C8.4352 16.9623 8.54933 16.9999 8.66667 16.9999C8.78401 16.9999 8.89813 16.9623 8.99167 16.8929L10.8333 15.4055L12.1333 16.8929C12.4888 17.1551 13 16.9061 13 16.4679V0.532088C13 0.0938532 12.4922 -0.155144 12.1333 0.107133ZM10.8333 11.9528C10.8333 12.0988 10.7115 12.2184 10.5625 12.2184H2.4375C2.28854 12.2184 2.16667 12.0988 2.16667 11.9528V11.4216C2.16667 11.2755 2.28854 11.156 2.4375 11.156H10.5625C10.7115 11.156 10.8333 11.2755 10.8333 11.4216V11.9528ZM10.8333 8.7656C10.8333 8.91168 10.7115 9.0312 10.5625 9.0312H2.4375C2.28854 9.0312 2.16667 8.91168 2.16667 8.7656V8.2344C2.16667 8.08833 2.28854 7.96881 2.4375 7.96881H10.5625C10.7115 7.96881 10.8333 8.08833 10.8333 8.2344V8.7656ZM10.8333 5.57843C10.8333 5.72451 10.7115 5.84403 10.5625 5.84403H2.4375C2.28854 5.84403 2.16667 5.72451 2.16667 5.57843V5.04724C2.16667 4.90116 2.28854 4.78164 2.4375 4.78164H10.5625C10.7115 4.78164 10.8333 4.90116 10.8333 5.04724V5.57843Z"
                fill="#E3E9FF"
              />
            </svg>
          </div>
          <div class="fast-commands-widget__item-text">
            {{ $t('fast_commands.create-payout') }}
          </div>
          <div class="fast-commands-widget__item-arrow">
            <arrow-button></arrow-button>
          </div>
        </router-link>
      </require-access>
    </div>
  </div>
</template>

<script>
import ArrowButton from '@vue-app/components/base/button/ArrowButton.vue'
import { mapState } from 'vuex'
import RequireAccess from '@vue-app/components/base/role-based/RequireAccess.vue'

export default {
  name: 'DashboardFastCommandsWidget',
  components: { RequireAccess, ArrowButton },
  props: {
    company: {
      required: true,
      type: Object,
    },
  },
  computed: {
    ...mapState(['selectedCompany']),
  },
}
</script>

<style lang="scss" scoped>
@import '@css-app/variables';
@import '@css-app/mixins';
.fast-commands-widget {
  background: #ffffff;
  box-shadow: 0px 20px 30px rgba(225, 235, 253, 0.38);
  border-radius: 20px;
  padding: 22px;
  &__header {
    display: flex;
    align-items: center;
  }

  &__icon {
    background: #64748B;
    border-radius: 15px;
    width: 44px;
    height: 44px;

    display: flex;
    align-items: center;
    justify-content: center;

    margin-right: 22px;

    svg,
    img {
      max-width: 100%;
      max-height: 100%;
    }
  }

  &__title {
    font-size: pxToRem(16);
    line-height: pxToRem(20);
    color: #b9c4d8;
  }

  &__list {
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    margin-top: 11px;
  }

  &__item {
    padding: 12px 24px;
    background: rgba(227, 233, 255, 0.2);
    border-radius: 16px;
    margin-bottom: 15px;
    display: flex;
    align-items: center;
    text-decoration: none;

    &:last-child {
      margin-bottom: 0;
    }

    &-icon {
      width: 20px;
      height: 20px;

      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 25px;

      img,
      svg {
        max-width: 100%;
        max-height: 100%;
      }
    }

    &-text {
      font-weight: 500;
      font-size: pxToRem(14);
      line-height: pxToRem(17);
      color: #b9c4d8;
      text-decoration: none;
    }

    &-arrow {
      margin-left: auto;
    }
  }
}
</style>
